import "./App.css";
import Home from "./pages/OuterPages/Home/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/Auth/Login/Login";
import SignUp from "./pages/Auth/SignUp/SignUp";
import ResetPassword from "./pages/Auth/ResetPassword/ResetPassword";
import ForgotPassword from "./pages/Auth/ForgotPassword/ForgotPassword";

import Guidelines from "./pages/Guidelines/Guidelines";
import Application from "./pages/Application/Application";
import DashboardCategory from "./pages/DashboardCategory/DashboardCategory";
import { useEffect } from "react";
import {
  Apiurl,
  ClearLocalStorage,
  GetLocalStorage,
  GetLocalStorageParsed,
  SetLocalStorage,
  SetLocalStorageStringify,
} from "./Utils/Utils";
import axios from "axios";
import CategoryInfo from "./pages/CategoryInfo/CategoryInfo";
import Category from "./pages/Admin/Category/Category";
import SubCategory from "./pages/Admin/SubCategory/SubCategory";
import DashboardLayout from "./pages/Admin/DashboardLayout/DashboardLayout";
import RegistrationForm from "./pages/Admin/RegistrationForm/RegistrationForm";
import ApplicationTabs from "./pages/Admin/ApplicationTabs/ApplicationTabs";
import ApplicationSections from "./pages/Admin/ApplicationSections/ApplicationSections";
import FormFields from "./pages/Admin/FormFields/FormFields";
import Users from "./pages/Admin/Users/Users";
import { LanguageProvider } from "./components/LanguageProvider/LanguageProvider ";
import AdminLogin from "./pages/Admin/AdminLogin/AdminLogin";
import AdminResetPassword from "./pages/Admin/AdminResetPassword/AdminResetPassword";
import AdminForgotPassword from "./pages/Admin/AdminForgotPassword/AdminForgotPassword";
import RegistrationFormAdd from "./pages/Admin/RegistrationForm/RegistrationFormAdd";
import AdminLoginAdd from "./pages/Admin/AdminLogin/AdminLoginAdd";
import AdminResetPasswordAdd from "./pages/Admin/AdminResetPassword/AdminResetPasswordAdd";
import AdminForgotPasswordAdd from "./pages/Admin/AdminForgotPassword/AdminForgotPasswordAdd";
import CategoryAdd from "./pages/Admin/Category/CategoryAdd";
import SubCategoryAdd from "./pages/Admin/SubCategory/SubCategoryAdd";
import AdminGuidelines from "./pages/Admin/AdminGuidelines/AdminGuidelines";
import AdminGuidelineslist from "./pages/Admin/AdminGuidelines/AdminGuidelineslist";
import AddRoles from "./pages/Admin/userRoles/AddRoles";
import RolesList from "./pages/Admin/userRoles/RolesList";
import UserPermissions from "./pages/Admin/userRoles/user-permissions";
import AdminUsers from "./pages/Admin/AdminUsers/AdminUsers";
import UserPermissionList from "./pages/Admin/userRoles/userPermissionList";
import ViewData from "./components/viewData/viewData";
import States from "./pages/Admin/SettingsTabs/States";
import Districts from "./pages/Admin/SettingsTabs/Districts";
import Cities from "./pages/Admin/SettingsTabs/Cities";
import AddAdminUser from "./pages/Admin/AdminUsers/AddAdminUser";
import AdminCategoryFaq from "./pages/Admin/AdminCategoryFaq/AdminCategoryFaq";
import AddAdminCategoryFaqs from "./pages/Admin/AdminCategoryFaq/AddAdminCategoryFaqs";
import EmployeeDesignation from "./pages/Admin/Employee Designation/EmployeeDesignation";
import AddEmployeeDesignation from "./pages/Admin/Employee Designation/AddEmployeeDesignation";
import TotalApplication from "./pages/Admin/Application/TotalApplication";
import PendingApplication from "./pages/Admin/Application/PendingApplication";
import RejectedApplications from "./pages/Admin/Application/RejectedApplications";
import ApprovedApplications from "./pages/Admin/Application/ApprovedApplications";
import RenewalApplications from "./pages/Admin/Application/RenewalApplications";
import AddDropDown from "./pages/Admin/dropDown/AddDropDown";
import DropDownList from "./pages/Admin/dropDown/DropDownList";
import SmsSettingPage from "./pages/Admin/setting Page/SmsSettingPage";
import EmailSettingPage from "./pages/Admin/setting Page/EmailSettingPage";
// import UserLog from "./pages/Admin/user-log/UserLog";
import AddAdminSubSection from "./pages/Admin/AdminSubSection/AddAdminSubSection";
import AdminSubSectionList from "./pages/Admin/AdminSubSection/AdminSubSectionList";
import NotFound from "./components/notFound/notFound";
import PermissionDenied from "./components/notFound/PermissionDenied";
import UploadDocument from "./pages/Admin/uploadDocument/UploadDocument";
import AddUploadDocument from "./pages/Admin/uploadDocument/AddUploadDocument";
import ChangePassword from "./components/User/ChangePassword";
import EditProfile from "./components/User/EditProfile";
import ChangeRequest from "./components/User/ChangeRequest";
import { getRefreshToken, userLogout } from "./services/api/user";
import {
  checkPermission,
  permissionsConfig,
} from "./pages/Admin/AdminPermission/PermissionChecker";
import MobileEmailVerification from "./pages/Admin/SettingsTabs/MobileEmailVerfication";
import Preview from "./components/Application/preview";
import ComingSoon from "./components/ComingSoon/ComingSoon";
import ApplicationDraft from "./components/Application/ApplicationDraft";
import Applications from "./components/Application/Applications";
import Certificate from "./components/Certificate/Certificate";
import PaymentRecipt from "./components/Payment/PaymentRecipt";
import Transactions from "./components/Payment/Transactions";
import Categories from "./components/CategoryInfo/Categories";
import Forms from "./components/Application/Forms";
import AdminCertificates from "./pages/Admin/AdminCertificates/AdminCertificates";
import AdminActiveCertificates from "./pages/Admin/AdminCertificates/AdminActiveCertificates";
import AdminExpiredCertificates from "./pages/Admin/AdminCertificates/AdminExpiredCertificates";
import FrontendUserList from "./pages/Admin/UsersList/FrontendUserList";
import UserLogs from "./pages/Admin/Users/UserLogs";
import OtpLogs from "./pages/Admin/Users/OtpLogs";
import BannerPage from "./pages/Admin/Pages/BannerPage";
import BannerLinks from "./pages/Admin/Pages/BannerLinks";
import CategoryFees from "./pages/Admin/Category/CategoryFees";
import CategoryFeesAdd from "./pages/Admin/Category/CategoryFeesAdd";
import ContactUs from "./components/Home/ContactUs";
import PrivacyPolicy from "./components/Home/PrivacyPolicy";
import BannerPageUpdate from "./pages/Admin/Pages/BannerPageUpdate";
import BannerLinksUpdate from "./pages/Admin/Pages/BannerLinksUpdate";
import ApplicationView from "./pages/Admin/ApplicationView/ApplicationView";
import HomepageHeader from "./pages/Admin/Pages/HomepageHeader";
import HomepageLogo from "./pages/Admin/Pages/HomepageLogo";
import HomepageLogoUpdate from "./pages/Admin/Pages/HomepageLogoUpdate";
import EditPrivacyPolicy from "./pages/Admin/Pages/EditPrivacyPolicy";
import EditTermsConditions from "./pages/Admin/Pages/EditTermsConditions";
import EditDisclaimer from "./pages/Admin/Pages/EditDisclaimer";
import EditNiyamvali from "./pages/Admin/Pages/EditNiyamvali";
import PrivacyPolicyGuidelinesUpdate from "./pages/Admin/Pages/PrivacyPolicyGuidelinesUpdate";
import SocialMedialLinksUpdate from "./pages/Admin/Pages/SocialMediaLinksUpdate";
import PaymentUpdatePage from "./pages/Admin/SettingsTabs/PaymentUpdatePage";
import UpdatePaymentStatus from "./pages/Admin/SettingsTabs/UpdatePaymentStatus";
import TermsAndConditions from "./components/Home/TermsAndConditions";
import Disclaimer from "./components/Home/Disclaimer";
import Rules from "./pages/Admin/Pages/Rules";
import PageDocument from "./pages/Admin/Pages/PageDocument";
import AddPageDocument from "./pages/Admin/Pages/AddPageDocument";
import HomepageRules from "./components/Home/HomepageRules";
import TrackApplication from "./components/Payment/TrackApplication";
import PrivateRoute from "./Utils/PrivateRoute";
import RecoverFrontendUsers from "./pages/Admin/UsersList/RecoverFrontendUsers";
import RecoverAdminUsers from "./pages/Admin/AdminUsers/RecoverAdminUsers";
import AllApplications from "./pages/Admin/AdminReports/AllApplications";
import ActiveApplications from "./pages/Admin/AdminReports/ActiveApplications";
import ApprovedApplicationsReport from "./pages/Admin/AdminReports/ApprovedApplications";
import DraftApplications from "./pages/Admin/AdminReports/DraftApplications";
import InActiveApplications from "./pages/Admin/AdminReports/InActiveApplications";
import PendingApplications from "./pages/Admin/AdminReports/PendingApplications";
import RejectsApplications from "./pages/Admin/AdminReports/RejectsApplications";
import UnderReviewApplications from "./pages/Admin/AdminReports/UnderReviewApplications";
import { FontSizeProvider } from "./components/FontSizeProvider/FontSizeProvider";
import Notification from "./components/Notification/Notification";
import WithdrawalApplications from "./pages/Admin/Application/WithdrawalApplications";
import DraftApplicationList from "./pages/Admin/Application/DraftApplications";
import UserDetails from "./pages/Admin/Users/UserDetails";
import UnderReviewApplication from "./pages/Admin/Application/UnderRviewApplications";
import ChangeUserPassword from "./pages/Admin/AdminUsers/ChangeUserPassword";
import AddYearlytarget from "./pages/Admin/AdminUsers/AddYearlytarget";
import YearlyTarget from "./pages/Admin/AdminUsers/YearlyTarget";
import CertificateCategory from "./pages/Admin/Certificate Category/CertificateCategory";
import CertificateCategoryAdd from "./pages/Admin/Certificate Category/CertificateCategoryAdd";
import YearlyTagetLogs from "./pages/Admin/AdminUsers/YearlyTagetLogs";
import NewRenewApplications from "./pages/Admin/Application/NewRenewApplications";
import UnderReviewRenewApplications from "./pages/Admin/Application/UnderReviewRenewApplications";
import DocumentPendingRenewApplications from "./pages/Admin/Application/DocumentPendingRenewApplications";
import AcceptedRenewApplications from "./pages/Admin/Application/AcceptedRenewApplications";
import RejectedRenewApplications from "./pages/Admin/Application/RejectedRenewApplications";
import ExpiredRenewApplications from "./pages/Admin/Application/ExpiredRenewApplications";
import AllRenewApplications from "./pages/Admin/Application/AllRenewApplications";
import NewApplications from "./pages/Admin/Application/NewApplications";
import ExpiredApplications from "./pages/Admin/Application/ExpiredApplications";
import DisableApplications from "./pages/Admin/Application/DisableApplications";
import DisableRenewApplications from "./pages/Admin/Application/DisableRenewApplications";
import EditSocialMediaLink from "./pages/Admin/Pages/EditSocialMediaLink";
import AdminPosting from "./pages/Admin/AdminUsers/AdminPosting";
import RegularDisableApplications from "./pages/Admin/Application/RegularDisableApplications";
import NavigationProvider from "./components/NavigationProvider/NavigationProvider";
import DynamicPage from "./pages/Dynamic/DynamicPage";
import HeaderPages from "./pages/Admin/Pages/HeaderPages";
import TopFooterPages from "./pages/Admin/Pages/TopFooterPages";
import BootomFooterPages from "./pages/Admin/Pages/BootomFooterPages";
import AddPages from "./pages/Admin/Pages/AddPages";
import EmailLog from "./pages/Admin/email-log/EmailLog";
import TravelTradeLinks from "./pages/Admin/Pages/TravelTradeLinks";
import AddTravelTradeLink from "./pages/Admin/Pages/AddTravelTradeLink";
import FooterContent from "./pages/Admin/Pages/FooterContent";
import RegistrationSteps from "./pages/Admin/Pages/RegistrationSteps";
import EditRegistrationStep from "./pages/Admin/Pages/EditRegistrationStep";
import HeaderContent from "./pages/Admin/Pages/HeaderContent";
import Configuration from "./pages/Admin/setting Page/Configuration";
import AdminYearlyTarget from "./pages/Admin/AdminUsers/AdminYearlyTarget";
import YearlyTargetReport from "./pages/Admin/AdminReports/YearlyTargetReport";
import TransactionList from "./pages/Admin/Application/TransactionList";
import AdminLogs from "./pages/Admin/AdminUsers/AdminLogs";
import SuperAdminLogs from "./pages/Admin/AdminUsers/SuperAdminLogs";
import AdminContactUs from "./pages/Admin/Pages/AdminContactUs";
import EditAdminContactUs from "./pages/Admin/Pages/EditAdminContactUs";
import PdfViewer from "./components/Pdf/PdfViewer";
import { useIdleTimer } from 'react-idle-timer';
import DocsViewer from "./components/Pdf/DocsViewer";
import PaymentDocumentRejectedRenewApplications from "./pages/Admin/Application/PaymentDocumentRejectedRenewApplications";
import PaymentDocumentRejectedApplications from "./pages/Admin/Application/PaymentDocumentRejectedApplications";
import OldApplication from "./components/Application/OldApplication";
import OldDocument from "./components/Application/OldDocument";
import OldDocumentView from "./components/Application/OldDocumentView";
import OldApplications from "./pages/Admin/UsersList/OldApplications";
import OldApplicationView from "./pages/Admin/UsersList/OldApplicationView";
import OldDocumentsAdmin from "./pages/Admin/UsersList/OldDocumentsAdmin";
import OldDocumentViewAdmin from "./pages/Admin/UsersList/OldDocumentViewAdmin";
import CategoriesApplicationReport from "./pages/Admin/AdminReports/CategoriesApplicationReport";
import UserPendingApplications from "./pages/Admin/Application/UserPendingApplications";
import DTDOPendingApplications from "./pages/Admin/Application/DTDOPendingApplications";
import PendingApplicationsDetails from "./pages/Admin/Application/PendingApplicationsDetails";
import FlagUsers from "./pages/Admin/UsersList/FlagUsers";
import MobileVersions from "./pages/Admin/setting Page/MobileVersions";
import VisitorTracking from "./components/VisitorTracking/VisitorTracking";
import EditVisitorTracking from "./components/VisitorTracking/EditVisitorTracking";
import AdminVisitorTracking from "./components/VisitorTracking/AdminVisitorTracking";
import AdminVisitorTrackingView from "./components/VisitorTracking/AdminVisitorTrackingView";
import ProvisionalCertificate from "./components/Certificate/ProvisionalCertificate";
import RevisedPolicyPaymentDueApplications from "./pages/Admin/Application/RevisedPolicyPaymentDueApplications";


function App() {
  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     const tokenExpiry = GetLocalStorageParsed("tokenExpiry"); // Fetch the latest token expiry
  //     if (tokenExpiry) {
  //       const expiryDate = new Date(tokenExpiry);
  //       const currentDate = new Date();
  //       const timeDifference = expiryDate - currentDate;
  //       // If token is about to expire (1 minutes left)
  //       if (timeDifference > 0 && timeDifference <= 600000) {
  //         refToken(); // Refresh token
  //       } else if (timeDifference <= 0) {
  //         refToken(); // Token has already expired
  //       }
  //     }
  //   }, 1000); // Check every second (1000 ms)
  //   // Clean up the interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, []);

  // const refToken = async () => {
  //   const refreshToken = await getRefreshToken();
  //   if (refreshToken) {
  //     SetLocalStorage("userInfo", refreshToken["refresh-token"]);
  //     SetLocalStorageStringify("tokenExpiry", refreshToken["expire_at"]);
  //   }
  // };
  // Simplified permission checks using the permissions config
  const superAminPermission = checkPermission("0", "0", "");

  const grantPermissionForViewCategories = checkPermission(
    permissionsConfig.viewCategories.role,
    permissionsConfig.viewCategories.action,
    permissionsConfig.viewCategories.type
  );
  const grantPermissionForViewSubCategories = checkPermission(
    permissionsConfig.viewSubCategories.role,
    permissionsConfig.viewSubCategories.action,
    permissionsConfig.viewSubCategories.type
  );
  const grantPermissionForViewGuidelines = checkPermission(
    permissionsConfig.viewGuidelines.role,
    permissionsConfig.viewGuidelines.action,
    permissionsConfig.viewGuidelines.type
  );
  const grantPermissionForViewCategoryFAQList = checkPermission(
    permissionsConfig.viewCategoryFAQList.role,
    permissionsConfig.viewCategoryFAQList.action,
    permissionsConfig.viewCategoryFAQList.type
  );
  const grantPermissionForViewDocumentList = checkPermission(
    permissionsConfig.viewDocumentList.role,
    permissionsConfig.viewDocumentList.action,
    permissionsConfig.viewDocumentList.type
  );

  const grantPermissionForViewCategoryFees = checkPermission(
    permissionsConfig.viewCategoryFees.role,
    permissionsConfig.viewCategoryFees.action,
    permissionsConfig.viewCategoryFees.type
  );

  const grantPermissionForViewFormTabs = checkPermission(
    permissionsConfig.viewFormTabs.role,
    permissionsConfig.viewFormTabs.action,
    permissionsConfig.viewFormTabs.type
  );
  const grantPermissionForViewFormSection = checkPermission(
    permissionsConfig.viewFormSection.role,
    permissionsConfig.viewFormSection.action,
    permissionsConfig.viewFormSection.type
  );
  const grantPermissionForViewFormSubSection = checkPermission(
    permissionsConfig.viewFormSubSection.role,
    permissionsConfig.viewFormSubSection.action,
    permissionsConfig.viewFormSubSection.type
  );
  const grantPermissionForViewFormFields = checkPermission(
    permissionsConfig.viewFormFields.role,
    permissionsConfig.viewFormFields.action,
    permissionsConfig.viewFormFields.type
  );
  const grantPermissionForViewFormDropdowns = checkPermission(
    permissionsConfig.viewFormDropdowns.role,
    permissionsConfig.viewFormDropdowns.action,
    permissionsConfig.viewFormDropdowns.type
  );
  const grantPermissionForViewEmployeeDesignation = checkPermission(
    permissionsConfig.viewEmployeeDesignation.role,
    permissionsConfig.viewEmployeeDesignation.action,
    permissionsConfig.viewEmployeeDesignation.type
  );

  // const grantPermissionForTotalApplications = checkPermission(permissionsConfig.totalApplications.role, permissionsConfig.totalApplications.action, permissionsConfig.totalApplications.type);
  // const grantPermissionForViewPending = checkPermission(permissionsConfig.viewPending.role, permissionsConfig.viewPending.action, permissionsConfig.viewPending.type);
  // const grantPermissionForViewApproved = checkPermission(permissionsConfig.viewApproved.role, permissionsConfig.viewApproved.action, permissionsConfig.viewApproved.type);
  // const grantPermissionForViewRejected = checkPermission(permissionsConfig.viewRejected.role, permissionsConfig.viewRejected.action, permissionsConfig.viewRejected.type);

  // const grantPermissionForCertificates = checkPermission(permissionsConfig.certificates.role, permissionsConfig.certificates.action, permissionsConfig.certificates.type);
  // const grantPermissionForExpired = checkPermission(permissionsConfig.expired.role, permissionsConfig.expired.action, permissionsConfig.expired.type);

  const grantPermissionForViewLogin = checkPermission(
    permissionsConfig.viewLogin.role,
    permissionsConfig.viewLogin.action,
    permissionsConfig.viewLogin.type
  );
  const grantPermissionForViewResetPassword = checkPermission(
    permissionsConfig.viewResetPassword.role,
    permissionsConfig.viewResetPassword.action,
    permissionsConfig.viewResetPassword.type
  );
  const grantPermissionForViewForgotPassword = checkPermission(
    permissionsConfig.viewForgotPassword.role,
    permissionsConfig.viewForgotPassword.action,
    permissionsConfig.viewForgotPassword.type
  );
  const grantPermissionForViewRegistration = checkPermission(
    permissionsConfig.viewRegistration.role,
    permissionsConfig.viewRegistration.action,
    permissionsConfig.viewRegistration.type
  );

  const grantPermissionForViewHeaderContent = checkPermission(
    permissionsConfig.viewHeaderContent.role,
    permissionsConfig.viewHeaderContent.action,
    permissionsConfig.viewHeaderContent.type
  );

  const grantPermissionForViewContactUs = checkPermission(
    permissionsConfig.viewContactUs.role,
    permissionsConfig.viewContactUs.action,
    permissionsConfig.viewContactUs.type
  );

  const grantPermissionForViewWebsiteLogo = checkPermission(
    permissionsConfig.viewWebsiteLogo.role,
    permissionsConfig.viewWebsiteLogo.action,
    permissionsConfig.viewWebsiteLogo.type
  );

  const grantPermissionForViewHeaderPages = checkPermission(
    permissionsConfig.viewHeaderPages.role,
    permissionsConfig.viewHeaderPages.action,
    permissionsConfig.viewHeaderPages.type
  );

  const grantPermissionForViewBanner = checkPermission(
    permissionsConfig.viewBanner.role,
    permissionsConfig.viewBanner.action,
    permissionsConfig.viewBanner.type
  );

  const grantPermissionForViewBannerLinks = checkPermission(
    permissionsConfig.viewBannerLinks.role,
    permissionsConfig.viewBannerLinks.action,
    permissionsConfig.viewBannerLinks.type
  );

  const grantPermissionForViewRegistrationStep = checkPermission(
    permissionsConfig.viewRegistrationStep.role,
    permissionsConfig.viewRegistrationStep.action,
    permissionsConfig.viewRegistrationStep.type
  );

  const grantPermissionForViewSocialMediaLinks = checkPermission(
    permissionsConfig.viewSocialMediaLinks.role,
    permissionsConfig.viewSocialMediaLinks.action,
    permissionsConfig.viewSocialMediaLinks.type
  );

  const grantPermissionForViewTravelTradeLink = checkPermission(
    permissionsConfig.viewTravelTradeLinks.role,
    permissionsConfig.viewTravelTradeLinks.action,
    permissionsConfig.viewTravelTradeLinks.type
  );

  const grantPermissionForViewTopFooterPages = checkPermission(
    permissionsConfig.viewTopFooterPages.role,
    permissionsConfig.viewTopFooterPages.action,
    permissionsConfig.viewTopFooterPages.type
  );

  const grantPermissionForViewBottomFooterPages = checkPermission(
    permissionsConfig.viewBottomFooterPages.role,
    permissionsConfig.viewBottomFooterPages.action,
    permissionsConfig.viewBottomFooterPages.type
  );

  const grantPermissionForViewPageDocument = checkPermission(
    permissionsConfig.viewPageDocument.role,
    permissionsConfig.viewPageDocument.action,
    permissionsConfig.viewPageDocument.type
  );

  const grantPermissionForViewFooterContent = checkPermission(
    permissionsConfig.viewFooterContent.role,
    permissionsConfig.viewFooterContent.action,
    permissionsConfig.viewFooterContent.type
  );

  const grantPermissionForRolesAndPermissions = checkPermission(
    permissionsConfig.viewRolesAndPermissions.role,
    permissionsConfig.viewRolesAndPermissions.action,
    permissionsConfig.viewRolesAndPermissions.type
  );

  const grantPermissionForViewAdminUser = checkPermission(
    permissionsConfig.viewAdminUser.role,
    permissionsConfig.viewAdminUser.action,
    permissionsConfig.viewAdminUser.type
  );

  const grantPermissionForViewRecoverAdminUser = checkPermission(
    permissionsConfig.viewRecoverAdminUser.role,
    permissionsConfig.viewRecoverAdminUser.action,
    permissionsConfig.viewRecoverAdminUser.type
  );

  const grantPermissionForViewYearlyTarget = checkPermission(
    permissionsConfig.viewYearlyTarget.role,
    permissionsConfig.viewYearlyTarget.action,
    permissionsConfig.viewYearlyTarget.type
  );

  const grantPermissionForViewManageStates = checkPermission(
    permissionsConfig.viewStates.role,
    permissionsConfig.viewStates.action,
    permissionsConfig.viewStates.type
  );
  const grantPermissionForViewManageDistricts = checkPermission(
    permissionsConfig.viewDistricts.role,
    permissionsConfig.viewDistricts.action,
    permissionsConfig.viewDistricts.type
  );
  const grantPermissionForViewManageCities = checkPermission(
    permissionsConfig.viewCities.role,
    permissionsConfig.viewCities.action,
    permissionsConfig.viewCities.type
  );
  const grantPermissionForViewSMSSetting = checkPermission(
    permissionsConfig.viewSMSSetting.role,
    permissionsConfig.viewSMSSetting.action,
    permissionsConfig.viewSMSSetting.type
  );
  const grantPermissionForViewEmailSetting = checkPermission(
    permissionsConfig.viewEmailSetting.role,
    permissionsConfig.viewEmailSetting.action,
    permissionsConfig.viewEmailSetting.type
  );

  const grantPermissionForViewConfiguration = checkPermission(
    permissionsConfig.viewConfiguration.role,
    permissionsConfig.viewConfiguration.action,
    permissionsConfig.viewConfiguration.type
  );

  const grantPermissionForViewPaymentSetting = checkPermission(
    permissionsConfig.viewPaymentSetting.role,
    permissionsConfig.viewPaymentSetting.action,
    permissionsConfig.viewPaymentSetting.type
  );

  const grantPermissionForViewTotalApplications = checkPermission(
    permissionsConfig.viewTotalApplications.role,
    permissionsConfig.viewTotalApplications.action,
    permissionsConfig.viewTotalApplications.type
  );

  const grantPermissionForViewNewApplications = checkPermission(
    permissionsConfig.viewNewApplications.role,
    permissionsConfig.viewNewApplications.action,
    permissionsConfig.viewNewApplications.type
  );

  const grantPermissionForViewUnderReviewApplications = checkPermission(
    permissionsConfig.viewUnderReviewApplications.role,
    permissionsConfig.viewUnderReviewApplications.action,
    permissionsConfig.viewUnderReviewApplications.type
  );

  const grantPermissionForViewPendingApplications = checkPermission(
    permissionsConfig.viewPendingApplications.role,
    permissionsConfig.viewPendingApplications.action,
    permissionsConfig.viewPendingApplications.type
  );
  const grantPermissionForViewApprovedApplications = checkPermission(
    permissionsConfig.viewApprovedApplications.role,
    permissionsConfig.viewApprovedApplications.action,
    permissionsConfig.viewApprovedApplications.type
  );
  const grantPermissionForViewRejectedApplications = checkPermission(
    permissionsConfig.viewRejectedApplications.role,
    permissionsConfig.viewRejectedApplications.action,
    permissionsConfig.viewRejectedApplications.type
  );

  const grantPermissionForViewRejectedPaymentDocumentApplications = checkPermission(
    permissionsConfig.viewPaymentDocumentRejectedApplications.role,
    permissionsConfig.viewPaymentDocumentRejectedApplications.action,
    permissionsConfig.viewPaymentDocumentRejectedApplications.type
  );

  const grantPermissionForViewExpiredApplications = checkPermission(
    permissionsConfig.viewExpiredApplications.role,
    permissionsConfig.viewExpiredApplications.action,
    permissionsConfig.viewExpiredApplications.type
  );

  const grantPermissionForViewDisabledApplications = checkPermission(
    permissionsConfig.viewDisabledApplications.role,
    permissionsConfig.viewDisabledApplications.action,
    permissionsConfig.viewDisabledApplications.type
  );

  const grantPermissionForViewDraftApplications = checkPermission(
    permissionsConfig.viewDraftApplications.role,
    permissionsConfig.viewDraftApplications.action,
    permissionsConfig.viewDraftApplications.type
  );

  const grantPermissionForViewWithdrawalApplications = checkPermission(
    permissionsConfig.viewWithdrawalApplications.role,
    permissionsConfig.viewWithdrawalApplications.action,
    permissionsConfig.viewWithdrawalApplications.type
  );

  const grantPermissionForViewTotalRenewApplications = checkPermission(
    permissionsConfig.viewRenewTotalApplications.role,
    permissionsConfig.viewRenewTotalApplications.action,
    permissionsConfig.viewRenewTotalApplications.type
  );

  const grantPermissionForViewNewRenewApplications = checkPermission(
    permissionsConfig.viewRenewNewApplications.role,
    permissionsConfig.viewRenewNewApplications.action,
    permissionsConfig.viewRenewNewApplications.type
  );

  const grantPermissionForViewUnderReviewRenewApplications = checkPermission(
    permissionsConfig.viewRenewUnderReviewApplications.role,
    permissionsConfig.viewRenewUnderReviewApplications.action,
    permissionsConfig.viewRenewUnderReviewApplications.type
  );

  const grantPermissionForViewPendingRenewApplications = checkPermission(
    permissionsConfig.viewRenewPendingApplications.role,
    permissionsConfig.viewRenewPendingApplications.action,
    permissionsConfig.viewRenewPendingApplications.type
  );
  const grantPermissionForViewApprovedRenewApplications = checkPermission(
    permissionsConfig.viewRenewApprovedApplications.role,
    permissionsConfig.viewRenewApprovedApplications.action,
    permissionsConfig.viewRenewApprovedApplications.type
  );
  const grantPermissionForViewRejectedRenewApplications = checkPermission(
    permissionsConfig.viewRenewRejectedApplications.role,
    permissionsConfig.viewRenewRejectedApplications.action,
    permissionsConfig.viewRenewRejectedApplications.type
  );

  const grantPermissionForViewPaymentDocumentRejectedRenewApplications = checkPermission(
    permissionsConfig.viewRenewPaymentDocumentRejectedApplications.role,
    permissionsConfig.viewRenewPaymentDocumentRejectedApplications.action,
    permissionsConfig.viewRenewPaymentDocumentRejectedApplications.type
  );

  const grantPermissionForViewExpiredRenewApplications = checkPermission(
    permissionsConfig.viewRenewExpiredApplications.role,
    permissionsConfig.viewRenewExpiredApplications.action,
    permissionsConfig.viewRenewExpiredApplications.type
  );

  const grantPermissionForViewDisabledRenewApplications = checkPermission(
    permissionsConfig.viewRenewDisabledApplications.role,
    permissionsConfig.viewRenewDisabledApplications.action,
    permissionsConfig.viewRenewDisabledApplications.type
  );

  const grantPermissionForViewTransactionsList = checkPermission(
    permissionsConfig.viewTransactions.role,
    permissionsConfig.viewTransactions.action,
    permissionsConfig.viewTransactions.type
  );

  const grantPermissionForViewDistrictTotalApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictTotalApplicationsReport.role,
    permissionsConfig.viewDistrictTotalApplicationsReport.action,
    permissionsConfig.viewDistrictTotalApplicationsReport.type
  );

  const grantPermissionForViewDistrictPendingApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictPendingApplicationsReport.role,
    permissionsConfig.viewDistrictPendingApplicationsReport.action,
    permissionsConfig.viewDistrictPendingApplicationsReport.type
  );

  const grantPermissionForViewDistrictDraftApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictDraftApplicationsReport.role,
    permissionsConfig.viewDistrictDraftApplicationsReport.action,
    permissionsConfig.viewDistrictDraftApplicationsReport.type
  );

  const grantPermissionForViewDistrictAcceptedCertificateApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictAcceptedCertificateApplicationsReport.role,
    permissionsConfig.viewDistrictAcceptedCertificateApplicationsReport.action,
    permissionsConfig.viewDistrictAcceptedCertificateApplicationsReport.type
  );

  const grantPermissionForViewDistrictRejectedApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictRejectedApplicationsReport.role,
    permissionsConfig.viewDistrictRejectedApplicationsReport.action,
    permissionsConfig.viewDistrictRejectedApplicationsReport.type
  );

  const grantPermissionForViewDistrictUnderReviewApplicationsReport = checkPermission(
    permissionsConfig.viewDistrictUnderReviewApplicationsReport.role,
    permissionsConfig.viewDistrictUnderReviewApplicationsReport.action,
    permissionsConfig.viewDistrictUnderReviewApplicationsReport.type
  );

  const grantPermissionForViewDistrictYearlyTargetReport = checkPermission(
    permissionsConfig.viewDistrictYearlyTargetReport.role,
    permissionsConfig.viewDistrictYearlyTargetReport.action,
    permissionsConfig.viewDistrictYearlyTargetReport.type
  );

  const grantPermissionForViewOTPLogs = checkPermission(
    permissionsConfig.viewOTPLogs.role,
    permissionsConfig.viewOTPLogs.action,
    permissionsConfig.viewOTPLogs.type
  );

  const grantPermissionForViewAdminLogs = checkPermission(
    permissionsConfig.viewAdminLogs.role,
    permissionsConfig.viewAdminLogs.action,
    permissionsConfig.viewAdminLogs.type
  );

  const grantPermissionForViewUserLogs = checkPermission(
    permissionsConfig.viewUserLogs.role,
    permissionsConfig.viewUserLogs.action,
    permissionsConfig.viewUserLogs.type
  );

  const grantPermissionForViewEmailLogs = checkPermission(
    permissionsConfig.viewEmailLogs.role,
    permissionsConfig.viewEmailLogs.action,
    permissionsConfig.viewEmailLogs.type
  );

  const grantPermissionForViewUserList = checkPermission(
    permissionsConfig.viewUserList.role,
    permissionsConfig.viewUserList.action,
    permissionsConfig.viewUserList.type
  );

  const grantPermissionForViewUpdateDetailsRequest = checkPermission(
    permissionsConfig.viewUpdateDetailsRequest.role,
    permissionsConfig.viewUpdateDetailsRequest.action,
    permissionsConfig.viewUpdateDetailsRequest.type
  );

  const grantPermissionForViewRecoverUser = checkPermission(
    permissionsConfig.viewRecoverUser.role,
    permissionsConfig.viewRecoverUser.action,
    permissionsConfig.viewRecoverUser.type
  );

  const ClearCache = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
      },
      url: `${Apiurl()}/clear-cache`,
    };
    axios(option)
      .then((e) => { })
      .catch((error) => { });
  };
  useEffect(() => {
    ClearCache();

    // const handleRightClick = (e) => {
    //   e.preventDefault();
    // };

    // // Disable F12 (dev tools)
    // const handleKeyDown = (e) => {
    //   if (e.key === 'F12') {
    //     e.preventDefault();
    //   }
    // };

    // // Add event listeners for both right-click and F12 key
    // document.addEventListener('contextmenu', handleRightClick);
    // document.addEventListener('keydown', handleKeyDown);

    // return () => {
    //   // Clean up event listeners
    //   document.removeEventListener('contextmenu', handleRightClick);
    //   document.removeEventListener('keydown', handleKeyDown);
    // };

  }, []);

  useEffect(() => {
    const disableRightClick = (event) => {
      event.preventDefault(); // Prevent the default right-click menu
    };

    const disableDevTools = (event) => {
      // Check for F12 key or specific key combinations
      if (
        event.key === 'F12' || // F12
        (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J' || event.key === 'C')) || // Ctrl+Shift+I/J/C
        (event.ctrlKey && event.key === 'U') || // Ctrl+U (View Source)
        (event.ctrlKey && event.shiftKey && event.key === 'U') || // Ctrl+Shift+U (View Source in some browsers)
        (event.altKey && event.shiftKey && event.key === 'I') || // Alt+Shift+I (DevTools in some browsers)
        (event.ctrlKey && event.shiftKey && event.key === 'K') || // ctrl+shirt+k (DevTools in firefox)
        (event.ctrlKey && event.shiftKey && event.key === 'E')  // ctrl+shirt+E (DevTools in firefox)
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener('contextmenu', disableRightClick); // Disable right-click
    document.addEventListener('keydown', disableDevTools); // Disable F12 and DevTools shortcuts

    // Cleanup the event listeners on component unmount
    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
      document.removeEventListener('keydown', disableDevTools);
    };
  }, []);

  const onIdle = async () => {
    const authToken = sessionStorage.getItem('userInfo') || localStorage.getItem('userInfo');

    // If user is logged in then remove the token and redirect back to login page
    if (authToken != null) {
      console.log("User logged out due to inactivity")
      const logout = await userLogout();
      if (logout) {
        window.location.href = "/login";
        ClearLocalStorage();
      }

    }
  };

  const onAction = (event) => {
    // console.log("User action detected");
    // console.log(event)
  }

  const onActive = () => {
    // console.log("User is active");
  }

  useIdleTimer({
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'],
    timeout: 15 * 60 * 1000, // 10 minutes idle timeout
    onIdle,
    onActive,
    onAction,
    debounce: 500, // Debounce events to optimize performance
  });

  return (
    <FontSizeProvider>
      <LanguageProvider>
        <BrowserRouter>
          <NavigationProvider>
            <PrivateRoute roles={["superadmin", "admin", "user"]}>
              <Routes>
                <Route path="/notFound" element={<NotFound />} />
                <Route path="/notification" element={<Notification />} />
                <Route path="/" element={<Home />} />
                <Route path="/:name" element={<DynamicPage />} />
                <Route path="/categoryInfo" element={<CategoryInfo />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/application-preview" element={<Preview />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/guidelines" element={<Guidelines />} />
                <Route path="/dashboard" element={<DashboardCategory />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/edit-profile" element={<EditProfile />} />
                <Route path="/change-request" element={<ChangeRequest />} />
                <Route path="/coming-soon" element={<ComingSoon />} />
                <Route path="/application-draft" element={<ApplicationDraft />} />
                <Route path="/old-application" element={<OldApplication />} />
                <Route path="/old-documents" element={<OldDocument />} />
                <Route path="/old-document-view" element={<OldDocumentView />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/certificate" element={<Certificate />} />
                <Route path="/provisional-certificate" element={<ProvisionalCertificate />} />
                <Route path="/payment-recipt" element={<PaymentRecipt />} />
                <Route path="/transactions" element={<Transactions />} />
                <Route path="/track-application" element={<TrackApplication />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/forms" element={<Forms />} />
                <Route path="/application/*" element={<Application />} />
                <Route path="/visitor-tracking" element={<VisitorTracking />} />
                <Route path="/edit-visitor-tracking" element={<EditVisitorTracking />} />
                <Route path="/admin/visitor-tracking" element={<AdminVisitorTracking />} />
                <Route path="/admin/visitor-tracking-view" element={<AdminVisitorTrackingView />} />
                {/* Admin Routes */}
                <Route path="/admin/view" element={<ViewData />} />
                <Route
                  path="/admin/categories/"
                  element={
                    grantPermissionForViewCategories ? (
                      <Category />
                    ) : (
                      <Category />
                    )
                  }
                />
                <Route
                  path="/admin/categories/:name"
                  element={
                    grantPermissionForViewCategories ? (
                      <CategoryAdd />
                    ) : (
                      <CategoryAdd />
                    )
                  }
                />
                <Route
                  path="/admin/sub-categories"
                  element={
                    grantPermissionForViewSubCategories ? (
                      <SubCategory />
                    ) : (
                      <SubCategory />
                    )
                  }
                />
                <Route
                  path="/admin/sub-categories/:name"
                  element={
                    grantPermissionForViewSubCategories ? (
                      <SubCategoryAdd />
                    ) : (
                      <SubCategoryAdd />
                    )
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <PrivateRoute roles={["superadmin", "admin"]}>
                      <DashboardLayout />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/admin/registration"
                  element={
                    grantPermissionForViewRegistration ? (
                      <RegistrationForm />
                    ) : (
                      <RegistrationForm />
                    )
                  }
                />
                <Route
                  path="/admin/registration/:name"
                  element={
                    grantPermissionForViewRegistration ? (
                      <RegistrationFormAdd />
                    ) : (
                      <RegistrationFormAdd />
                    )
                  }
                />
                <Route
                  path="/admin/form/tabs"
                  element={
                    grantPermissionForViewFormTabs ? (
                      <ApplicationTabs />
                    ) : (
                      <ApplicationTabs />
                    )
                  }
                />
                <Route
                  path="/admin/form/sections"
                  element={
                    grantPermissionForViewFormSection ? (
                      <ApplicationSections />
                    ) : (
                      <ApplicationSections />
                    )
                  }
                />
                <Route path="/admin/change-password" element={<ChangePassword />} />
                <Route
                  path="/admin/form/fields"
                  element={
                    grantPermissionForViewFormFields ? (
                      <FormFields />
                    ) : (
                      <FormFields />
                    )
                  }
                />
                <Route path="/admin/users" element={<Users />} />
                <Route
                  path="/admin/login"
                  element={
                    grantPermissionForViewLogin ? (
                      <AdminLogin />
                    ) : (
                      <AdminLogin />
                    )
                  }
                />
                <Route
                  path="/admin/login/:name"
                  element={
                    grantPermissionForViewLogin ? (
                      <AdminLoginAdd />
                    ) : (
                      <AdminLoginAdd />
                    )
                  }
                />
                <Route
                  path="/admin/reset-password"
                  element={
                    grantPermissionForViewResetPassword ? (
                      <AdminResetPassword />
                    ) : (
                      <AdminResetPassword />
                    )
                  }
                />
                <Route
                  path="/admin/reset-password/:name"
                  element={
                    grantPermissionForViewResetPassword ? (
                      <AdminResetPasswordAdd />
                    ) : (
                      <AdminResetPasswordAdd />
                    )
                  }
                />
                <Route
                  path="/admin/forgot-password"
                  element={
                    grantPermissionForViewForgotPassword ? (
                      <AdminForgotPassword />
                    ) : (
                      <AdminForgotPassword />
                    )
                  }
                />
                <Route
                  path="/admin/forgot-password/:name"
                  element={
                    grantPermissionForViewForgotPassword ? (
                      <AdminForgotPasswordAdd />
                    ) : (
                      <AdminForgotPasswordAdd />
                    )
                  }
                />
                <Route
                  path="/admin/guidelines/:name"
                  element={
                    grantPermissionForViewGuidelines ? (
                      <AdminGuidelines />
                    ) : (
                      <AdminGuidelines />
                    )
                  }
                />
                <Route
                  path="/admin/guidelines"
                  element={
                    grantPermissionForViewGuidelines ? (
                      <AdminGuidelineslist />
                    ) : (
                      <AdminGuidelineslist />
                    )
                  }
                />
                <Route
                  path="/admin/roles/:name"
                  element={
                    grantPermissionForRolesAndPermissions ? (
                      <AddRoles />
                    ) : (
                      <AddRoles />
                    )
                  }
                />
                <Route
                  path="/admin/roles"
                  element={
                    grantPermissionForRolesAndPermissions ? (
                      <RolesList />
                    ) : (
                      <RolesList />
                    )
                  }
                />
                <Route
                  path="/admin/roles/permissions/:name"
                  element={
                    grantPermissionForRolesAndPermissions ? (
                      <UserPermissions />
                    ) : (
                      <UserPermissions />
                    )
                  }
                />
                <Route
                  path="/admin/admin-users/user-permissions/edit"
                  element={
                    grantPermissionForViewAdminUser ? (
                      <UserPermissions />
                    ) : (
                      <UserPermissions />
                    )
                  }
                />
                <Route
                  path="/admin/admin-users/change-passwword"
                  element={
                    grantPermissionForViewAdminUser ? (
                      <ChangeUserPassword />
                    ) : (
                      <ChangeUserPassword />
                    )
                  }
                />
                <Route
                  path="/admin/roles/permissions"
                  element={
                    grantPermissionForRolesAndPermissions ? (
                      <UserPermissionList />
                    ) : (
                      <UserPermissionList />
                    )
                  }
                />
                <Route
                  path="/admin/admin-users"
                  element={
                    grantPermissionForViewAdminUser ? (
                      <AdminUsers />
                    ) : (
                      <AdminUsers />
                    )
                  }
                />
                <Route
                  path="/admin/category/documents"
                  element={
                    grantPermissionForViewDocumentList ? (
                      <UploadDocument />
                    ) : (
                      <UploadDocument />
                    )
                  }
                />
                <Route
                  path="/admin/category/fees"
                  element={
                    grantPermissionForViewCategoryFees ? (
                      <CategoryFees />
                    ) : (
                      <CategoryFees />
                    )
                  }
                />
                <Route
                  path="/admin/category/fees/:name"
                  element={
                    grantPermissionForViewCategoryFees ? (
                      <CategoryFeesAdd />
                    ) : (
                      <CategoryFeesAdd />
                    )
                  }
                />
                <Route
                  path="/admin/category/documents/:name"
                  element={
                    grantPermissionForViewDocumentList ? (
                      <AddUploadDocument />
                    ) : (
                      <AddUploadDocument />
                    )
                  }
                />
                <Route path="/admin/permissions" element={<UserPermissions />} />
                <Route
                  path="/admin/states"
                  element={
                    grantPermissionForViewManageStates ? (
                      <States />
                    ) : (
                      <States />
                    )
                  }
                />
                <Route
                  path="/admin/districts"
                  element={
                    grantPermissionForViewManageDistricts ? (
                      <Districts />
                    ) : (
                      <Districts />
                    )
                  }
                />
                <Route
                  path="/admin/cities"
                  element={
                    grantPermissionForViewManageCities ? (
                      <Cities />
                    ) : (
                      <Cities />
                    )
                  }
                />
                <Route
                  path="/admin/admin-users/:name"
                  element={
                    grantPermissionForViewAdminUser ? (
                      <AddAdminUser />
                    ) : (
                      <AddAdminUser />
                    )
                  }
                />

                <Route
                  path="/admin/faqs"
                  element={
                    grantPermissionForViewCategoryFAQList ? (
                      <AdminCategoryFaq />
                    ) : (
                      <AdminCategoryFaq />
                    )
                  }
                />
                <Route
                  path="/admin/FAQs/:name"
                  element={
                    grantPermissionForViewCategoryFAQList ? (
                      <AddAdminCategoryFaqs />
                    ) : (
                      <AddAdminCategoryFaqs />
                    )
                  }
                />
                <Route
                  path="/admin/employee-designations"
                  element={
                    grantPermissionForViewEmployeeDesignation ? (
                      <EmployeeDesignation />
                    ) : (
                      <EmployeeDesignation />
                    )
                  }
                />
                <Route
                  path="/admin/employee-designations/:name"
                  element={
                    grantPermissionForViewEmployeeDesignation ? (
                      <AddEmployeeDesignation />
                    ) : (
                      <AddEmployeeDesignation />
                    )
                  }
                />
                <Route path="/admin/new-applications" element={
                  grantPermissionForViewNewApplications ? (
                    <NewApplications />
                  ) : (
                    <NewApplications />
                  )
                }
                />
                <Route path="/admin/revised-policy-payment-due-applications" element={
                  grantPermissionForViewNewApplications ? (
                    <RevisedPolicyPaymentDueApplications />
                  ) : (
                    <RevisedPolicyPaymentDueApplications />
                  )
                }
                />
                <Route path="/admin/expired-applications" element={
                  grantPermissionForViewExpiredApplications ? (
                    <ExpiredApplications />
                  ) : (
                    <ExpiredApplications />
                  )
                }
                />
                <Route
                  path="/admin/total-applications"
                  element={
                    grantPermissionForViewTotalApplications ? (
                      <TotalApplication />
                    ) : (
                      <TotalApplication />
                    )
                  }
                />
                <Route
                  path="/admin/user-pending-applications"
                  element={
                    grantPermissionForViewTotalApplications ? (
                      <UserPendingApplications />
                    ) : (
                      <UserPendingApplications />
                    )
                  }
                />
                <Route
                  path="/admin/dtdo-pending-applications"
                  element={
                    grantPermissionForViewTotalApplications ? (
                      <DTDOPendingApplications />
                    ) : (
                      <DTDOPendingApplications />
                    )
                  }
                />
                <Route
                  path="/admin/pending-applications"
                  element={
                    grantPermissionForViewPendingApplications ? (
                      <PendingApplication />
                    ) : (
                      <PendingApplication />
                    )
                  }
                />
                <Route
                  path="/admin/rejected-applications"
                  element={
                    grantPermissionForViewRejectedApplications ? (
                      <RejectedApplications />
                    ) : (
                      <RejectedApplications />
                    )
                  }
                />
                <Route path="/admin/payment-document-rejected-applications" element={
                  grantPermissionForViewRejectedPaymentDocumentApplications ? (
                    <PaymentDocumentRejectedApplications />
                  ) : (
                    <PaymentDocumentRejectedApplications />
                  )
                }
                />
                <Route
                  path="/admin/approved-applications"
                  element={
                    grantPermissionForViewApprovedApplications ? (
                      <ApprovedApplications />
                    ) : (
                      <ApprovedApplications />
                    )
                  }
                />
                <Route
                  path="/admin/renewal-applications"
                  element={<RenewalApplications />}
                />
                <Route
                  path="/admin/under-review-applications"
                  element={
                    grantPermissionForViewUnderReviewApplications ? (
                      <UnderReviewApplication />
                    ) : (
                      <UnderReviewApplication />
                    )
                  }
                />
                <Route
                  path="/admin/disable-applications"
                  element={
                    grantPermissionForViewDisabledApplications ? (
                      <RegularDisableApplications />
                    ) : (
                      <RegularDisableApplications />
                    )
                  }
                />
                <Route
                  path="/admin/transaction-list"
                  element={
                    grantPermissionForViewTransactionsList ? (
                      <TransactionList />
                    ) : (
                      <TransactionList />
                    )
                  }
                />
                <Route
                  path="/admin/form/dropdowns/:name"
                  element={
                    grantPermissionForViewFormDropdowns ? (
                      <AddDropDown />
                    ) : (
                      <AddDropDown />
                    )
                  }
                />
                <Route
                  path="/admin/form/dropdowns"
                  element={
                    grantPermissionForViewFormDropdowns ? (
                      <DropDownList />
                    ) : (
                      <DropDownList />
                    )
                  }
                />
                <Route
                  path="/admin/sms-setting"
                  element={
                    grantPermissionForViewSMSSetting ? (
                      <SmsSettingPage />
                    ) : (
                      <SmsSettingPage />
                    )
                  }
                />
                <Route
                  path="/admin/configurations"
                  element={
                    grantPermissionForViewConfiguration ? (
                      <Configuration />
                    ) : (
                      <Configuration />
                    )
                  } />
                <Route
                  path="/admin/mobile-verison"
                  element={
                    grantPermissionForViewConfiguration ? (
                      <MobileVersions />
                    ) : (
                      <MobileVersions />
                    )
                } />
                <Route
                  path="/admin/email-setting"
                  element={
                    grantPermissionForViewEmailSetting ? (
                      <EmailSettingPage />
                    ) : (
                      <EmailSettingPage />
                    )
                  }
                />
                <Route path="/admin/email-log" element={
                  grantPermissionForViewEmailLogs ? (
                    <EmailLog />
                  ) : (
                    <EmailLog />
                  )
                }
                />
                <Route
                  path="/admin/form/sub-sections/:name"
                  element={
                    grantPermissionForViewFormSubSection ? (
                      <AddAdminSubSection />
                    ) : (
                      <AddAdminSubSection />
                    )
                  }
                />
                <Route
                  path="/admin/form/sub-sections"
                  element={
                    grantPermissionForViewFormSubSection ? (
                      <AdminSubSectionList />
                    ) : (
                      <AdminSubSectionList />
                    )
                  }
                />
                <Route
                  path="/admin/request/mobile-email"
                  element={
                    grantPermissionForViewUpdateDetailsRequest ? (
                      <MobileEmailVerification />
                    ) : (
                      <MobileEmailVerification />
                    )
                  } />
                <Route path="/admin/certificates" element={<AdminCertificates />} />
                <Route
                  path="/admin/active-certificates"
                  element={<AdminActiveCertificates />}
                />
                <Route
                  path="/admin/expired-certificates"
                  element={<AdminExpiredCertificates />}
                />
                <Route path="/admin/user" element={
                  grantPermissionForViewUserList ? (
                    <FrontendUserList />
                  ) : (
                    <FrontendUserList />
                  )
                } />
                <Route path="/admin/flag-users" element={
                  grantPermissionForViewUserList ? (
                    <FlagUsers />
                  ) : (
                    <FlagUsers />
                  )
                } />
                <Route path="/admin/old-applications" element={<OldApplications />} />
                <Route path="/admin/old-application-view" element={<OldApplicationView />} />
                <Route path="/admin/old-document" element={<OldDocumentsAdmin />} />
                <Route path="/admin/old-documents-view" element={<OldDocumentViewAdmin />} />
                <Route path="/admin/user-logs-list" element={
                  grantPermissionForViewUserLogs ? (
                    <UserLogs />
                  ) : (
                    <UserLogs />
                  )
                } />
                <Route path="/admin/admin-logs-list" element={
                  grantPermissionForViewAdminLogs ? (
                    <AdminLogs />
                  ) : (
                    <AdminLogs />
                  )
                } />
                <Route path="/admin/superadmin-logs-list" element={
                  superAminPermission ? (
                    <SuperAdminLogs />
                  ) : (
                    <SuperAdminLogs />
                  )
                } />
                <Route path="/admin/otp-logs" element={
                  grantPermissionForViewOTPLogs ? (
                    <OtpLogs />
                  ) : (
                    <OtpLogs />
                  )
                } />
                <Route path="/admin/banner-page" element={
                  grantPermissionForViewBanner ? (
                    <BannerPage />
                  ) : (
                    <BannerPage />
                  )
                } />
                <Route path="/admin/banner-link" element={
                  grantPermissionForViewBannerLinks ? (
                    <BannerLinks />
                  ) : (
                    <BannerLinks />
                  )
                }
                />
                <Route path="/contact-us" element={<ContactUs />} />
                {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
                <Route
                  path="/admin/header-content"
                  element={
                    grantPermissionForViewHeaderContent ? (
                      <HeaderContent />
                    ) : (
                      <HeaderContent />
                    )
                  }
                />
                <Route
                  path="/admin/contactus/:name"
                  element={
                    grantPermissionForViewContactUs ? (
                      <EditAdminContactUs />
                    ) : (
                      <EditAdminContactUs />
                    )
                  }
                />
                <Route
                  path="/admin/contactus"
                  element={
                    grantPermissionForViewContactUs ? (
                      <AdminContactUs />
                    ) : (
                      <AdminContactUs />
                    )
                  }
                />
                <Route
                  path="/admin/footer-content"
                  element={
                    grantPermissionForViewFooterContent ? (
                      <FooterContent />
                    ) : (
                      <FooterContent />
                    )
                  }
                />
                <Route
                  path="/admin/registration-steps"
                  element={
                    grantPermissionForViewRegistrationStep ? (
                      <RegistrationSteps />
                    ) : (
                      <RegistrationSteps />
                    )
                  }
                />
                <Route
                  path="/admin/registration-steps/:name"
                  element={
                    grantPermissionForViewRegistrationStep ? (
                      <EditRegistrationStep />
                    ) : (
                      <EditRegistrationStep />
                    )
                  }
                />
                <Route
                  path="/admin/travel-trade-links"
                  element={
                    grantPermissionForViewTravelTradeLink ? (
                      <TravelTradeLinks />
                    ) : (
                      <TravelTradeLinks />
                    )
                  }
                />
                <Route
                  path="/admin/travel-trade-links/:name"
                  element={
                    grantPermissionForViewTravelTradeLink ? (
                      <AddTravelTradeLink />
                    ) : (
                      <AddTravelTradeLink />
                    )
                  }
                />
                <Route
                  path="/admin/header-pages"
                  element={
                    grantPermissionForViewHeaderPages ? (
                      <HeaderPages />
                    ) : (
                      <HeaderPages />
                    )
                  }
                />
                <Route
                  path="/admin/top-footer-pages"
                  element={
                    grantPermissionForViewTopFooterPages ? (
                      <TopFooterPages />
                    ) : (
                      <TopFooterPages />
                    )
                  }
                />
                <Route
                  path="/admin/bottom-footer-pages"
                  element={
                    grantPermissionForViewBottomFooterPages ? (
                      <BootomFooterPages />
                    ) : (
                      <BootomFooterPages />
                    )
                  }
                />
                <Route
                  path="/admin/pages/:name"
                  element={
                    grantPermissionForViewHeaderPages || grantPermissionForViewTopFooterPages || grantPermissionForViewBottomFooterPages ? (
                      <AddPages />
                    ) : (
                      <AddPages />
                    )
                  }
                />
                {/* <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            /> */}
                <Route
                  path="/admin/rules"
                  element={<Rules />}
                />
                <Route
                  path="/admin/page-document"
                  element={
                    grantPermissionForViewPageDocument ? (
                      <PageDocument />
                    ) : (
                      <PageDocument />
                    )
                  }
                />
                <Route
                  path="/admin/page-document/add"
                  element={
                    grantPermissionForViewPageDocument ? (
                      <AddPageDocument />
                    ) : (
                      <AddPageDocument />
                    )
                  }
                />
                <Route
                  path="/admin/page-document/update"
                  element={
                    grantPermissionForViewPageDocument ? (
                      <AddPageDocument />
                    ) : (
                      <AddPageDocument />
                    )
                  }
                />
                {/* <Route
              path="/disclaimer"
              element={<Disclaimer />}
            /> */}
                <Route
                  path="/admin/banner-page/:name"
                  element={
                    grantPermissionForViewBanner ? (
                      <BannerPageUpdate />
                    ) : (
                      <BannerPageUpdate />
                    )
                  } />
                <Route
                  path="/admin/banner-link/update"
                  element={
                    grantPermissionForViewBannerLinks ? (
                      <BannerLinksUpdate />
                    ) : (
                      <BannerLinksUpdate />
                    )
                  }
                />
                {/* <Route
              path="/rules"
              element={<HomepageRules />}
            /> */}
                <Route path="/admin/application-view" element={<ApplicationView />} />
                <Route path="/admin/homepage-header" element={<HomepageHeader />} />
                <Route path="/admin/homepage-logo" element={
                  grantPermissionForViewWebsiteLogo ? (
                    <HomepageLogo />
                  ) : (
                    <HomepageLogo />
                  )
                } />
                <Route path="admin/certificate-type" element={<CertificateCategory />} />
                <Route path="admin/certificate-type/:name" element={<CertificateCategoryAdd />} />
                <Route
                  path="/admin/homepage-logo/update"
                  element={
                    grantPermissionForViewWebsiteLogo ? (
                      <HomepageLogoUpdate />
                    ) : (
                      <HomepageLogoUpdate />
                    )
                  } />
                <Route
                  path="/admin/privacy-policy/update"
                  element={<EditPrivacyPolicy />}
                />
                <Route
                  path="/admin/terms-conditions/update"
                  element={<EditTermsConditions />}
                />
                <Route path="/admin/disclaimer/update" element={<EditDisclaimer />} />

                <Route path="/admin/niyamvali/update" element={<EditNiyamvali />} />
                <Route
                  path="/admin/privacy-policy/update/guidelines"
                  element={<PrivacyPolicyGuidelinesUpdate />}
                />
                <Route
                  path="/admin/social-media-links/:name"
                  element={
                    grantPermissionForViewSocialMediaLinks ? (
                      <EditSocialMediaLink />
                    ) : (
                      <EditSocialMediaLink />
                    )
                  } />
                <Route
                  path="/admin/social-media-links"
                  element={
                    grantPermissionForViewSocialMediaLinks ? (
                      <SocialMedialLinksUpdate />
                    ) : (
                      <SocialMedialLinksUpdate />
                    )
                  }
                />
                <Route
                  path="/admin/district-posting-log"
                  element={<AdminPosting />}
                />
                <Route path="/admin/configuration" element={<Configuration />} />
                <Route path="/admin/notification" element={<Notification />} />
                <Route path="/admin/yearly-target-logs" element={<YearlyTagetLogs />} />
                <Route path="/admin/user-details" element={<UserDetails />} />
                <Route path="/admin/pending-applicaion-details" element={<PendingApplicationsDetails />} />
                <Route path="/admin/yearly-targets" element={
                  grantPermissionForViewYearlyTarget ? (
                    <AdminYearlyTarget />
                  ) : (
                    <AdminYearlyTarget />
                  )
                }
                />
                <Route path="/admin/add-yearly-targets" element={
                  grantPermissionForViewYearlyTarget ? (
                    <AddYearlytarget />
                  ) : (
                    <AddYearlytarget />
                  )
                }
                />
                <Route path="/admin/payment/tab" element={
                  grantPermissionForViewPaymentSetting ? (
                    <PaymentUpdatePage />
                  ) : (
                    <PaymentUpdatePage />
                  )
                }
                />
                <Route path="/admin/frontend-users" element={
                  grantPermissionForViewRecoverUser ? (
                    <RecoverFrontendUsers />
                  ) : (
                    <RecoverFrontendUsers />
                  )
                }
                />
                <Route path="/admin/recover-users" element={
                  grantPermissionForViewRecoverAdminUser ? (
                    <RecoverAdminUsers />
                  ) : (
                    <RecoverAdminUsers />
                  )
                }
                />
                <Route path="/admin/withdrawal-applications" element={
                  grantPermissionForViewWithdrawalApplications ? (
                    <WithdrawalApplications />
                  ) : (
                    <WithdrawalApplications />
                  )
                }
                />
                <Route path="/admin/draft-applications" element={
                  grantPermissionForViewDraftApplications ? (
                    <DraftApplicationList />
                  ) : (
                    <DraftApplicationList />
                  )
                }
                />
                <Route path="/admin/renew/new" element={
                  grantPermissionForViewNewRenewApplications ? (
                    <NewRenewApplications />
                  ) : (
                    <NewRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/under-review" element={
                  grantPermissionForViewUnderReviewRenewApplications ? (
                    <UnderReviewRenewApplications />
                  ) : (
                    <UnderReviewRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/document-pending" element={
                  grantPermissionForViewPendingRenewApplications ? (
                    <DocumentPendingRenewApplications />
                  ) : (
                    <DocumentPendingRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/accepted" element={
                  grantPermissionForViewApprovedRenewApplications ? (
                    <AcceptedRenewApplications />
                  ) : (
                    <AcceptedRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/rejected" element={
                  grantPermissionForViewRejectedRenewApplications ? (
                    <RejectedRenewApplications />
                  ) : (
                    <RejectedRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/payment-document-rejected" element={
                  grantPermissionForViewPaymentDocumentRejectedRenewApplications ? (
                    <PaymentDocumentRejectedRenewApplications />
                  ) : (
                    <PaymentDocumentRejectedRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/expired" element={
                  grantPermissionForViewExpiredRenewApplications ? (
                    <ExpiredRenewApplications />
                  ) : (
                    <ExpiredRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/disable" element={
                  grantPermissionForViewDisabledRenewApplications ? (
                    <DisableRenewApplications />
                  ) : (
                    <DisableRenewApplications />
                  )
                }
                />
                <Route path="/admin/renew/all" element={
                  grantPermissionForViewTotalRenewApplications ? (
                    <AllRenewApplications />
                  ) : (
                    <AllRenewApplications />
                  )
                }
                />
                <Route path="/admin/all-applications-report" element={
                  grantPermissionForViewDistrictTotalApplicationsReport ? (
                    <AllApplications />
                  ) : (
                    <AllApplications />
                  )
                }
                />
                <Route path="/admin/categories-applications-report" element={
                  grantPermissionForViewDistrictTotalApplicationsReport ? (
                    <CategoriesApplicationReport />
                  ) : (
                    <CategoriesApplicationReport />
                  )
                }
                />
                <Route path="/admin/all-active-report" element={<ActiveApplications />} />
                <Route path="/admin/all-inactive-report" element={<InActiveApplications />} />
                <Route path="/admin/all-pending-report" element={
                  grantPermissionForViewDistrictPendingApplicationsReport ? (
                    <PendingApplications />
                  ) : (
                    <PendingApplications />
                  )
                }
                />
                <Route path="/admin/all-draft-report" element={
                  grantPermissionForViewDistrictDraftApplicationsReport ? (
                    <DraftApplications />
                  ) : (
                    <DraftApplications />
                  )
                }
                />
                <Route path="/admin/all-approved-report" element={
                  grantPermissionForViewDistrictAcceptedCertificateApplicationsReport ? (
                    <ApprovedApplicationsReport />
                  ) : (
                    <ApprovedApplicationsReport />
                  )
                }
                />
                <Route path="/admin/all-rejected-report" element={
                  grantPermissionForViewDistrictRejectedApplicationsReport ? (
                    <RejectsApplications />
                  ) : (
                    <RejectsApplications />
                  )
                }
                />
                <Route path="/admin/all-under-review-report" element={
                  grantPermissionForViewDistrictUnderReviewApplicationsReport ? (
                    <UnderReviewApplications />
                  ) : (
                    <UnderReviewApplications />
                  )
                }
                />
                <Route path="/admin/yearly-target-report" element={
                  grantPermissionForViewDistrictYearlyTargetReport ? (
                    <YearlyTargetReport />
                  ) : (
                    <YearlyTargetReport />
                  )
                }
                />
                <Route path="/admin/traveltradepdf/pdfs/:folder1/:folder2?/:folder3?/:fileName" element={<PdfViewer />} />
                <Route path="/traveltradepdf/pdfs/:folder1/:folder2?/:folder3?/:fileName" element={<PdfViewer />} />
                <Route path="/traveltradedocs/docs/:folder1/:folder2?/:folder3?/:fileName" element={<DocsViewer />} />
                <Route path="/admin/traveltradedocs/docs/:folder1/:folder2?/:folder3?/:fileName" element={<DocsViewer />} />
              </Routes>
            </PrivateRoute>
          </NavigationProvider>
        </BrowserRouter>
      </LanguageProvider>
    </FontSizeProvider>
  );
}
export default App;
